__cw__define(['jquery', 'matchHeight'], function ($) {
  'use strict';

  $(document).ready(function () {
    // class a mettre sur le body pour détecter la fin du load. Rapport aux bugs ie transitions sur le loading
    $('body').removeClass('pageLoad');

    // fichier js permettant de loader les images en js. Objectif, diminuer le temps de page load pour google
    // Zone en commentaires: permet de loader les images seulement quand elles deviennent visibles. Inconvénient: ajoute un listener systématique sur le scroll, alourdi le travail du navigateur

    var lazyBG = document.querySelectorAll('.lazy-background');
    if (lazyBG.length > 0) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(lazyLoadBg, {
          rootMargin: '250px',
          threshold: 0
        });
        lazyBG.forEach(function (image) {
          observer.observe(image);
        });
      } else {
        lazyBG.forEach(function (image) {
          replaceSrclWithDataSrc(image.target);
          image.classList.add('visible');
        });
      }
    }
    function lazyLoadBg(elements) {
      elements.forEach(function (image) {
        if (image.intersectionRatio > 0) {
          replaceSrclWithDataSrc(image.target);
          image.target.classList.add('visible');
          observer.unobserve(image.target);
        }
      });
    }
    function replaceSrclWithDataSrc(element) {
      var src = element.getAttribute('data-src');
      if (src) {
        element.style.backgroundImage = "url('" + src + "')";
      }
    }
    function manageLazyImages() {
      $.each($('img.lazy'), function () {
        var self = $(this);

        // on lance le code au loading, mais on pourrait le faire sur le scoll, voir plus bas
        self.attr('src', self.attr('data-src'));
        $('.match-height').matchHeight();
        self.removeClass('lazy');

        // if (self.offset().top < ($(window).scrollTop() + $(window).height() + 100)) {
        //    self.attr('src', self.attr('data-src'));
        //    $('.match-height').matchHeight();
        //    self.removeClass('lazy');
        // }
      });
    }
    manageLazyImages();

    // window.onscroll = function () {
    //    manageLazyImages();
    // };

    // Pour gérer les match height (au loading l'image n'existe pas alors le match height ne peut s'activer)
    $.each($('.match-height img.lazy'), function () {
      var self = $(this);
      self.attr('src', self.attr('data-src'));
      self.parents('.match-height').matchHeight();
      self.removeClass('lazy');
    });
  });
});